module.exports = __webpack_public_path__ + "sipgate.svg?0e6fb2c189cf2b8b1e1fc929cab4ba5f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/sipgate.svg
// module id = 98
// module chunks = 0